import { Suspense, lazy } from 'react';

const ContactDealerInlineForm = lazy(() =>
    import(/* webpackChunkName: "ContactDealerInlineForm" */ './ContactDealerInlineForm')
);

export const ContactDealerInlineFormLoader = props => {
    return (
        <Suspense fallback={''}>
            <ContactDealerInlineForm {...props} />
        </Suspense>
    );
};
